import { Typography,  List } from 'antd';

const EventObjectives = ({ data }) => {
  
  return (
    <>
      <List
        bordered
        dataSource={data}
        renderItem={(item, index) => (
          <List.Item>
           <Typography.Text>{index+1}. </Typography.Text> {item.value}
          </List.Item>
        )}
      />
    </>
  )
}

export default EventObjectives